// Cada `name` es una llave i18n. Los renderers (ContainerMenu, AppSidebarNav)
// la pasan por $t(...) antes de mostrar.
export default [
    {
        component: 'CNavItem',
        name: 'nav.panel',
        access: 'panel',
        to: '/panel',
        icon: 'ti ti-device-desktop-analytics',
        glifo: 'panel',
    },
    {
        component: 'CNavGroup',
        name: 'nav.tareas',
        access: 'Tareas',
        to: '',
        icon: 'ti ti-subtask',
        glifo: 'tareas',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.tareasListado',
                access: 'tareas/mis-tareas',
                to: '/task-list',
            },
            {
                component: 'CNavItem',
                name: 'nav.tareasKanban',
                access: 'tareas/kanban',
                to: '/tareas/kanban',
            },
            {
                component: 'CNavItem',
                name: 'nav.tareasTiempos',
                access: 'tareas/attention-times-dashboard',
                to: '/tareas/tiempos-atencion',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.administracion',
        access: 'Administración',
        to: '',
        icon: 'ti ti-settings-cog',
        glifo: 'administracion',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.flujos',
                access: 'admin/flujos',
                to: '/flow-editor',
            },
            {
                component: 'CNavItem',
                name: 'nav.conexiones',
                access: 'admin/connections',
                to: '/connections/list',
            },
            {
                component: 'CNavItem',
                name: 'nav.alertas',
                access: 'admin/alerts',
                to: '/alerts/list',
            },
            {
                component: 'CNavItem',
                name: 'nav.variablesSistema',
                access: 'admin/system-vars',
                to: '/admin/system-vars',
            },
            {
                component: 'CNavItem',
                name: 'nav.menusPersonalizados',
                access: 'admin/menus',
                to: '/admin/menus',
            },
            {
                component: 'CNavItem',
                name: 'nav.sistema',
                access: 'admin/sistema',
                to: '/admin/sistema',
            },
            {
                component: 'CNavItem',
                name: 'nav.administrarMarcas',
                // No es un acceso por rol: lo habilita `brandAdmin` en la base.
                access: '__brandadmin',
                to: '/admin/marcas',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.usuarios',
        to: '',
        icon: 'ti ti-users',
        glifo: 'usuarios',
        access: 'Usuarios',
        items: [
            {
                component: 'CNavItem',
                access: 'users/admin',
                name: 'nav.usuariosAdmin',
                to: '/usuarios/listado',
            },
            {
                component: 'CNavItem',
                access: 'users/admin',
                name: 'nav.usuariosMetadata',
                to: '/usuarios/metadata',
            },
            {
                component: 'CNavItem',
                access: 'users/admin/grupos',
                name: 'nav.usuariosCanales',
                to: '/usuarios/canal/listado',
            },
            {
                component: 'CNavItem',
                access: 'users/admin/grupos',
                name: 'nav.usuariosGrupos',
                to: '/usuarios/grupo/listado',
            },
            {
                component: 'CNavItem',
                access: 'users/role/admin',
                name: 'nav.usuariosRoles',
                to: '/usuarios/roles/listado',
            },
            {
                component: 'CNavItem',
                access: 'users/jerarquia/admin',
                name: 'nav.usuariosJerarquia',
                to: '/usuarios/jerarquia/listado',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.paneles',
        access: 'paneles/listado',
        to: '',
        icon: 'ti ti-layout-dashboard',
        glifo: 'paneles',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.panelesConfig',
                access: 'paneles/config',
                to: '/paneles/config',
            },
            {
                component: 'CNavItem',
                name: 'nav.panelesMis',
                access: 'paneles/listado',
                to: '/paneles/listado',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.reportes',
        access: 'reportes',
        to: '',
        icon: 'ti ti-report-analytics',
        glifo: 'reportes',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.reportesConsumos',
                access: 'reportes/mis-consumos',
                to: '/reportes/mis-consumos',
            },
            {
                component: 'CNavItem',
                name: 'nav.reportesGenerar',
                access: 'reportes/generar',
                to: '/reportes/generar',
            },
            {
                component: 'CNavItem',
                name: 'nav.reportesDocs',
                access: 'reportes/download-docs',
                to: '/reportes/download-docs',
            },
            {
                component: 'CNavItem',
                name: 'nav.reportesDescargaMasiva',
                access: 'reportes/descarga-masiva',
                to: '/reportes/descarga-masiva',
            },
            {
                component: 'CNavItem',
                name: 'nav.reportesConfig',
                access: 'reportes/admin',
                to: '/reportes/configuracion',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.datos',
        access: 'data',
        to: '',
        icon: 'ti ti-database',
        glifo: 'datos',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.datosVer',
                access: 'data/view',
                to: '/data/view',
            },
            {
                component: 'CNavItem',
                name: 'nav.datosBases',
                access: 'data/databases',
                to: '/data/databases',
            },
            {
                component: 'CNavItem',
                name: 'nav.datosCatalogos',
                access: 'data/catalog',
                to: '/data/catalog',
            },
        ],
    },
    {
        component: 'CNavGroup',
        name: 'nav.reservas',
        access: 'reservas',
        to: '',
        icon: 'ti ti-calendar-time',
        glifo: 'reservas',
        items: [
            {
                component: 'CNavItem',
                name: 'nav.reservasMis',
                access: 'reservas/mis',
                to: '/reservas/mis',
            },
            {
                component: 'CNavItem',
                name: 'nav.reservasPanel',
                access: 'reservas/panel',
                to: '/reservas/panel',
            },
        ],
    },
]
